import React from "react";
import { useLang } from "../../context/lang-context";

const LandingHero: React.FC = () => {
  const { t } = useLang();

  return (
    <section className="hero-section">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-12 col-md-6 text-center text-md-start hero-text">
            <h1 className="hero-title">
              {t(
                "Pide tu comida favorita desde tu celular",
                "Order your favorite food from your phone"
              )}
            </h1>
            <p className="hero-subtitle">
              {t(
                "Descubre restaurantes cerca de ti, personaliza tu pedido y recíbelo en tu puerta o recógelo en el restaurante.",
                "Discover restaurants near you, customize your order and get it delivered to your door or pick it up at the restaurant."
              )}
            </p>
            <div className="hero-badges">
              <a
                href="https://apps.apple.com/us/app/foo-app/id1434604093"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/img/appstore-badge.png" alt="App Store" className="store-badge" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.fooappmx.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/img/google-play-badge.png" alt="Google Play" className="store-badge" />
              </a>
            </div>
          </div>
          <div className="col-10 col-md-5 text-center mt-4 mt-md-0">
            <img
              src="/img/iPhone-foo-screen-1@0.5x.png"
              alt={t("Foo App en tu celular", "Foo App on your phone")}
              className="hero-phone"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingHero;
